import { useAuth } from "@/core/components/auth/store/auth";
import { useSidebar } from "@/core/components/ui/sidebar";
import { DS_COLOR, DS_TYPOGRAPHY } from "@/core/lib/ds-typography";

/** Até duas iniciais do nome da empresa (avatar sem logo). */
export function getEntityInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
}

/**
 * "Entity Menu" da Sidebar do DS (Figma 6051:2744): empresa logada abaixo do
 * cabeçalho, com avatar quadrado (raio 8) em surface-accent-secondary e divisor
 * inferior. A API não expõe logo da empresa, então o avatar usa as iniciais.
 */
export function WosSidebarEntity() {
  const { userInfo } = useAuth();
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  const name = userInfo.league?.name || userInfo.user.first_name;

  return (
    <div
      className={`relative flex shrink-0 items-center gap-4 py-3 ${
        isCollapsed ? "justify-center px-1" : "px-4"
      }`}
      data-testid="wos-sidebar-entity"
    >
      <span
        aria-hidden
        className="flex shrink-0 items-center justify-center overflow-hidden rounded-lg border"
        style={{
          width: 36,
          height: 36,
          backgroundColor: DS_COLOR.surfaceAccentSecondary,
          borderColor: DS_COLOR.strokeDefault,
          ...DS_TYPOGRAPHY.labelXsmall,
          color: DS_COLOR.contentDefault,
        }}
      >
        {getEntityInitials(name)}
      </span>
      {!isCollapsed && (
        <span
          className="min-w-0 flex-1 truncate"
          style={{
            ...DS_TYPOGRAPHY.labelXsmall,
            color: DS_COLOR.contentDefault,
          }}
        >
          {name}
        </span>
      )}
      <span
        aria-hidden
        className="absolute bottom-0 h-px"
        style={{
          left: isCollapsed ? 4 : 16,
          right: isCollapsed ? 4 : 16,
          backgroundColor: DS_COLOR.strokeDefault,
        }}
      />
    </div>
  );
}
